import React from 'react';
import { TextInput } from '@abyss/web/ui/TextInput';
import { usePropsContext } from 'src/hooks/usePropsContext';
import { styled } from '@abyss/web/tools/styled';

const StyledTextInput = styled(TextInput, {
  'input::-webkit-contacts-auto-fill-button': {
    visibility: 'hidden',
    display: 'none !important',
    pointerEvents: 'none',
    position: 'absolute',
    right: 0,
  },
});

export const City = () => {
  const { modelPrefix, onBlur } = usePropsContext();

  return (
    <StyledTextInput
      width="50%"
      data-testid="city"
      label="City"
      model={`${modelPrefix}.city`}
      validators={{
        required: 'Please enter a value',
      }}
      isClearable
      onBlur={() => onBlur(`${modelPrefix}.city`)}
    />
  );
};
